import React from 'react';
import { Platform, Pressable, StyleSheet, View, useWindowDimensions } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';
import { useCoworkerStore } from '@/store/coworker';
import { useWorkLive } from './WorkLiveContext';
import WorkBrowserPreview from './WorkBrowserPreview';

export default function WorkBrowserArtifact({ artifact }) {
  const { colors } = useTheme();
  const { width } = useWindowDimensions();
  const live = useWorkLive();
  const openBrowserViewer = useCoworkerStore((s) => s.openBrowserViewer);
  if (!live?.taskId || (Platform.OS !== 'macos' && (Platform.OS !== 'web' || width < 768))) return null;
  let host = '';
  try { host = new URL(artifact.url).hostname.replace(/^www\./, ''); } catch { /* no navigation yet */ }
  const onOpen = () => openBrowserViewer(live.taskId, { watch: true });
  return (
    <View style={[styles.card, { backgroundColor: colors.solid_color_secondary, borderColor: colors.border_color_secondary }]}>
      <View style={styles.header}>
        <View style={[styles.icon, { backgroundColor: colors.solid_color_tertiary }]}>
          <Icon name="globe" size={20} color={colors.color_success} />
        </View>
        <View style={styles.copy}>
          <Text size="s" weight="semibold">Browser</Text>
          <Text size="xs" color="secondary" numberOfLines={1}>
            {artifact.isLive ? 'Browsing' : 'Browser session'}{host ? ` · ${host}` : ''}
          </Text>
        </View>
      </View>
      <WorkBrowserPreview taskId={live.taskId} previewId={artifact.id} isLive={artifact.isLive} onOpen={onOpen} style={styles.preview} />
      <Pressable accessibilityRole="button" accessibilityLabel="Open browser preview" onPress={onOpen}
        style={({ hovered, pressed }) => [styles.button, { backgroundColor: hovered || pressed ? colors.solid_color_primary : colors.solid_color_tertiary }]}>
        <Text size="s" weight="semibold">Open preview</Text>
        <Icon name="arrow-up-right-from-square" size={12} color={colors.text_color_secondary} />
      </Pressable>
    </View>
  );
}

const styles = StyleSheet.create({
  card: { width: 360, maxWidth: '100%', padding: 14, gap: 12, borderRadius: 18, borderWidth: StyleSheet.hairlineWidth, marginVertical: 12 },
  header: { flexDirection: 'row', alignItems: 'center', gap: 10 },
  icon: { width: 42, height: 42, borderRadius: 12, alignItems: 'center', justifyContent: 'center' },
  copy: { flex: 1, gap: 3, minWidth: 0 },
  preview: { marginHorizontal: 0, height: undefined, aspectRatio: 1280 / 800 },
  button: { minHeight: 40, borderRadius: 24, flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: 8 },
});
